export const CardLayout = ({ children, title, padding = 'p-20' }) => {
  return (
    <div className='rounded-2 overflow-hidden mb-5'>
      <div className='p-20 bg-second fw-bold text-white d-flex justify-content-between align-items-center'>{title}</div>
      <div className={`bg-white ${padding}`}>{children}</div>
    </div>
  );
};
